import { render, staticRenderFns } from "./correct-exam.vue?vue&type=template&id=3e4a9c0c&scoped=true&"
import script from "./correct-exam.vue?vue&type=script&lang=js&"
export * from "./correct-exam.vue?vue&type=script&lang=js&"
import style0 from "./correct-exam.vue?vue&type=style&index=0&id=3e4a9c0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4a9c0c",
  null
  
)

export default component.exports